import ProposalLoadError from "./ProposalLoadError";

export default ProposalLoadError;
